import styles from 'components/Cart/OrderSummary/HardwarePayment/HardwarePayment.module.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCheckout } from 'components/Checkout/CheckoutProvider';
import { TextV2 } from 'components/TextV2/TextV2';
import { Installments } from 'components/Cart/OrderSummary/types';
import { PRODUCT_LIST_TEST_ID } from './ProductList.const';
import {
  getCartProductsAndAccessories,
  isPayMonthlyAndCartHasProducts,
} from 'components/Cart/utils/getCartProductsAndAccessoriesUtils';
import { IProductModel } from 'components/Cart/models';
import { usePaymentsToggle } from 'components/Cart/OrderSummary/PaymentsToggle/usePaymentsToggle/usePaymentsToggle';
import { useCartContext } from 'components/Cart/hooks/useCartContext';

interface IProductListProps {
  isVermont?: boolean;
}

export const ProductList: React.FC<IProductListProps> = ({ isVermont = false }) => {
  const { t } = useTranslation();
  const { cart } = useCartContext();
  const { selectedPurchaseType } = useCheckout();
  const { isPayMonthly } = usePaymentsToggle();

  const { payInFullProductsAndAccessories, allCartProductsAndAccessories } =
    getCartProductsAndAccessories(cart);

  const isPayMonthlyAndCartHasPayInFullProducts = isPayMonthlyAndCartHasProducts(
    isPayMonthly,
    payInFullProductsAndAccessories,
  );

  const hardwareItems: IProductModel[] = isPayMonthlyAndCartHasPayInFullProducts
    ? payInFullProductsAndAccessories
    : allCartProductsAndAccessories;

  const shouldUsePayInFullPrice =
    selectedPurchaseType === Installments.P || isPayMonthlyAndCartHasPayInFullProducts || isVermont;

  return (
    <>
      {hardwareItems?.map(item => {
        const totalCost = shouldUsePayInFullPrice
          ? item.totalCost
          : item?.installmentPlans?.[selectedPurchaseType]?.value || 0;

        const productNameAndQuantity = item.quantity > 1 ? `${item.name} (${item.quantity})` : item.name;

        return (
          <div className={styles.container} key={item.id} data-testid={PRODUCT_LIST_TEST_ID.item}>
            <TextV2
              variant="body"
              tagName="span"
              value={productNameAndQuantity}
              className={styles.containerLabel}
              data-testid={PRODUCT_LIST_TEST_ID.name}
            />
            <TextV2
              variant="body"
              tagName="span"
              value={t('order-summary.price', { price: totalCost * item.quantity })}
              data-testid={PRODUCT_LIST_TEST_ID.cost}
            />
          </div>
        );
      })}
    </>
  );
};

ProductList.displayName = 'ProductList';
